import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://waywaystudio-1375d.firebaseio.com/'
})

export default instance;